import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalSidebar from '../components/LegalSidebar';
import { setPageSEO } from '../utils/seo.js';
import './Terms.css';

function GDPR() {
  useEffect(() => setPageSEO({
    title: 'GDPR Compliance - Clientalio',
    description: 'Discover how Clientalio complies with GDPR requirements to protect user privacy, personal data, and testimonial submissions.',
    canonical: 'https://clientalio.com/gdpr',
    ogTitle: 'GDPR Compliance - Clientalio',
    ogDescription: 'Discover how Clientalio complies with GDPR requirements to protect user privacy, personal data, and testimonial submissions.',
    twitterTitle: 'GDPR Compliance - Clientalio',
    twitterDescription: 'Discover how Clientalio complies with GDPR requirements to protect user privacy, personal data, and testimonial submissions.'
  }), []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="terms-page">
      <div className="container">
        <div className="terms-header">
          <h1>GDPR Compliance Policy</h1>
          <p className="last-updated">Last Updated: 06-Oct-2025</p>
        </div>
        <div className="terms-layout">
          <LegalSidebar activePage="gdpr" />

          {/* Main Content */}
          <div className="terms-content">
            <div className="content-section">

              <section className="terms-section">
                <h2>1. Introduction</h2>
                <p>
                  At Clientalio, we take your privacy seriously. We've implemented strict measures
                  to comply with the General Data Protection Regulation (GDPR) — ensuring that
                  your data is collected, processed, and stored responsibly.
                </p>
                <p>
                  For transparency about how we handle data, please review our related documents:
                </p>
                <ul className="legal-links">
                  <li><Link to="/terms-and-condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                </ul>
              </section>

              <section className="terms-section">
                <h2>2. About Us</h2>
                <p>
                  When you use Clientalio, you — as the user or organization — act as the data
                  controller. Clientalio acts as the data processor, and we process data only as
                  necessary to deliver our services. We do not send marketing emails to your
                  customers, do not share or sell data to third parties, and will delete your data upon
                  request in compliance with GDPR's Right to Erasure (Article 17).
                </p>
              </section>

              <section className="terms-section">
                <h2>3. Data Hosting and Storage</h2>
                <p>
                  All servers and databases powering Clientalio are securely hosted in on cloud
                  servers. Third parties used for technical, analytics, or support purposes are
                  contractually bound to applicable data protection terms.
                </p>
              </section>

              <section className="terms-section">
                <h2>4. Your GDPR Rights</h2>
                <p>
                  Under the GDPR you have rights including Access, Rectification, Erasure,
                  Restrict Processing, Data Portability, and the Right to Object. To exercise any of
                  these rights contact <a href="mailto:support@clientalio.com">support@clientalio.com</a>.
                </p>
              </section>

              <section className="terms-section">
                <h2>5. Security Measures</h2>
                <p>
                  We use end-to-end encryption for sensitive data, regular security audits, access
                  control, and authentication measures to protect your information.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GDPR;
